import React from 'react';

import { cellActions, determineCellAction } from './determine-cell-action';

import RemoveStagedRevision from './RemoveStagedRevision';
import StageForDelete from './StageForDelete';
import UndoStagedForDelete from './UndoStagedForDelete';
import UnmanagedWarning from './UnmanagedWarning';

export default function DeleteActions(row) {
  const cellAction = determineCellAction(row);

  switch (cellAction) {
    case cellActions.STAGE_FOR_DELETE:
      return <StageForDelete {...row} />;
    case cellActions.REMOVE_STAGED_REVISION:
      return <RemoveStagedRevision {...row} />;
    case cellActions.UNDO_STAGED_FOR_DELETE:
      return <UndoStagedForDelete {...row} />;
    case cellActions.UNMANAGED_WARNING:
      return <UnmanagedWarning />;
    default:
      throw new Error(`Unknown delete cell option: ${cellAction}`);
  }
}
